import { ILogo } from "./Logo.interface";
import LogoImg from "./../../shared/assets/imgs/logo.svg";
import LogoWhiteImg from "./../../shared/assets/imgs/logo_white.svg";

function Logo({ isWhite }: ILogo) {
    return <img src={isWhite ? LogoWhiteImg : LogoImg} className="logo" alt="Prosperh" />;
}

export default Logo;
